// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb_root__3wR68","breadcrumbLinks":"Breadcrumb_breadcrumbLinks__DmXrU","link":"Breadcrumb_link__20jvt"};